/* eslint-disable jsx-a11y/media-has-caption */
import * as React from 'react'

import { Grid } from '@material-ui/core'

import useStyles from './styles'

interface IGenerateVideoScriptModalProps {
  watchVideoURL?: string,
}

const GenerateVideoScriptModal: React.FunctionComponent<IGenerateVideoScriptModalProps> = ({ watchVideoURL }) => {
  const classes = useStyles()
  const videoRef = React.useRef<HTMLVideoElement>(null)

  const handleOnClick = () => {
    if (!videoRef?.current?.paused) {
      videoRef?.current?.play()
    } else {
      videoRef?.current?.pause()
    }
  }

  return (
    <Grid
      className={classes.root}
      container
      direction="column"
      justify="center"
    >
      <Grid item container xs={12}>
        <div className={classes.videoWrapper}>
          <video
            ref={videoRef}
            preload="metadata"
            playsInline
            controls
            onClick={handleOnClick}
          >
            <source src={watchVideoURL} type="video/mp4" />
          </video>
        </div>
      </Grid>
    </Grid>
  )
}

export default GenerateVideoScriptModal
